import Layout from '../view/layout.vue'
import Index from '../view/index.vue'
import Video from '../view/video.vue'
import Hot from '../view/hot.vue'
import Latest from '../view/latest.vue'
import Ranking from '../view/ranking.vue'
import Wallpaper from '../view/wallpaper.vue'
import PrivacyPolicy from '../view/privacyPolicy.vue'
import UserAgreement from '../view/userAgreement.vue'
import Qualifications from '../view/qualifications.vue'
import Login from '../view/login.vue'
import Rule from '../view/rule.vue'

const Router = [
  {
    path: '/',
    name: 'home',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        name: 'index',
        component: Index
      },
      {
        path: '/hot',
        name: 'hot',
        component: Hot
      },
      {
        path: '/latest',
        name: 'latest',
        component: Latest
      },
      {
        path: '/ranking',
        name: 'ranking',
        component: Ranking
      },
      {
        path: '/wallpaper',
        name: 'wallpaper',
        component: Wallpaper
      },
      {
        path: '/qualifications',
        name: 'qualifications',
        component: Qualifications
      },
      {
        path: '/privacyPolicy',
        name: 'privacyPolicy',
        component: PrivacyPolicy
      },
      {
        path: '/userAgreement',
        name: 'userAgreement',
        component: UserAgreement
      },
      {
        path: '/rule',
        name: 'rule',
        component: Rule
      }
    ]
  },
  {
    path: '/video',
    name: 'video',
    component: Video
  },

  {
    path: '/login',
    name: 'login',
    component: Login
  }
]
export default Router
